var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sc-card',[_c('div',{class:[`sc-title-bar ${_vm.$mq}`]},[_c('city-title',{attrs:{"city":_vm.city}}),_c('date-time',{attrs:{"time-zone":_vm.timeZone}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }